<template>
  <div class="banner">
    <upload @upload="onUpload" />
    <el-row :gutter="20">
      <el-col :span="16">
        <el-input v-model="bannerUrl" placeholder="http://" clearable @clear="onClearImageLink" />
      </el-col>
      <el-col :span="8">
        <el-button @click="onAddLink">
          Add link
        </el-button>
      </el-col>
    </el-row>
    <div class="desc">
      <p>You can upload image or add the public link to image.</p>
    </div>
  </div>
</template>

<script>
import Upload from '@/components/Upload';
import { mapState } from 'vuex';

export default {
  name: 'Banner',

  components: {
    Upload
  },

  data() {
    return {
      url: ''
    };
  },

  computed: {
    ...mapState(['addons']),
    bannerUrl: {
      get() {
        return this.addons.banner.link;
      },
      set(v) {
        this.url = v;
      }
    }
  },

  methods: {
    onUpload(url) {
      this.$store.dispatch('updateBanner', url);
    },

    onAddLink() {
      this.$store.dispatch('updateBanner', this.url);
    },
    onClearImageLink() {
      this.imageLink = '';
      this.onAddLink();
    }
  }
};
</script>

<style lang="scss"></style>
